import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
//import ApolloLinkTimeout from 'apollo-link-timeout';

export interface IFechaVencimientoQueryParams {
  rut_empresa: number;
  sucursal_codigo: number;
  cliente_proveedor_rut: number;
  direccion_codigo: number;
  fecha_documento: Date;
  condicion_pago_codigo: number;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentoService {
  constructor(private gqlclient: GraphQLClient) { }

  ObtenerTotalesDocumento(inputParams, callback: Function) {
    //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))

    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType) {
            documento {
              obtenerTotalesDocumento(entidadDTO: $entidadDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  subtotal
                  descuento
                  recargo
                  exento
                  afecto
                  neto
                  impto_adic
                  iva
                  total
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerTotalesDocumento;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerFechaVencimiento(inputParams: IFechaVencimientoQueryParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $cliente_proveedor_rut: Decimal, $direccion_codigo: Decimal, $fecha_documento: Date, $condicion_pago_codigo: Decimal) {
            documento {
              obtenerFechaVencimiento(
                filtro: { exacto: { empresa_rut: $rut_empresa, cliente_proveedor_rut: $cliente_proveedor_rut, codigo: $direccion_codigo, condicion_pago_codigo: $condicion_pago_codigo } }
                sucursal_codigo: $sucursal_codigo
                fecha_documento: $fecha_documento
              ) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  fecha_vencimiento
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerFechaVencimiento;
        callback({ mensajes, respuesta });
      }
    );
  }

  devuelveDocumento(
    inputParams: {
      nroRec: number;
      rutEmpresa: number;
      sucursalCodigo: number;
      nroDocto: number;
      tipoDocumento: number;
      motivoDevolucion: number;
      fechaEmision: Date;
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($nroRec: Decimal, $rutEmpresa: Decimal, $sucursalCodigo: Decimal, $nroDocto: Decimal, $tipoDocumento: Decimal, $motivoDevolucion: Decimal, $fechaEmision: Date) {
            documento {
              devuelveDocumento(
                nroRec: $nroRec
                rutEmpresa: $rutEmpresa
                sucursalCodigo: $sucursalCodigo
                nroDocto: $nroDocto
                tipoDocumento: $tipoDocumento
                motivoDevolucion: $motivoDevolucion
                fechaEmision: $fechaEmision
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.devuelveDocumento;
        callback({ mensajes, respuesta });
      }
    );
  }

  devuelveProductos(
    inputParams: {
      nroRec: number;
      motivoDevolucion: number;
      rutEmisor: number;
      sucursalCodigo: number;
      tipoDte: number;
      folio: number;
      detalleRef: any[];
      fechaEmision: Date;
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation (
            $nroRec: Decimal
            $motivoDevolucion: Decimal
            $rutEmisor: Decimal
            $sucursalCodigo: Decimal
            $tipoDte: Decimal
            $folio: Decimal
            $detalleRef: [documento_detalleDTOInputType]
            $fechaEmision: Date
          ) {
            documento {
              devuelveProductos(
                nroRec: $nroRec
                motivoDevolucion: $motivoDevolucion
                rutEmisor: $rutEmisor
                sucursalCodigo: $sucursalCodigo
                tipoDte: $tipoDte
                folio: $folio
                detalleRef: $detalleRef
                fechaEmision: $fechaEmision
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    sucursal_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.devuelveProductos;
        callback({ mensajes, respuesta });
      }
    );
  }

  guardarNotaCredito(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: documentoDTOInputType, $entidadReferencia: documentoInputType) {
            documento {
              guardarNotaCredito(entidad: $entidad, entidadReferencia: $entidadReferencia) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.guardarNotaCredito;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroVentaResumen(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroVentaResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    cantidad_documento
                    monto_afecto
                    monto_exento
                    impto_adic
                    monto_iva
                    monto_iva_no_recup
                    monto_total
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroVentaResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroVentaResumenExcel(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroVentaResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroVentaResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroVentaDetalle(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroVentaDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    fecha_registro
                    cliente_proveedor_rut
                    cliente_nombre
                    monto_afecto
                    monto_exento
                    impto_adic
                    monto_iva
                    monto_iva_no_recup
                    monto_total
                    es_casa_matriz
                    cantidad_documento
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroVentaDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerTotalesLibroVenta(inputParams, callback: Function) {
    //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))
    this.gqlclient.query(
      {
        query: gql`
          query ($lista: [documentoInputType]) {
            documento {
              obtenerTotalesLibroVenta(lista: $lista) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cantidad_documento
                  monto_afecto
                  monto_exento
                  impto_adic
                  monto_iva
                  monto_iva_no_recup
                  monto_total
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerTotalesLibroVenta;
        callback({ mensajes, respuesta });
      }
    );
  }
  obtenerLibroVentaDetalleExcel(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroVentaDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroVentaDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroCompraResumen(
    inputParams: {
      entidad: {
        rut_receptor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroCompraResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_receptor
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    cantidad_documento
                    monto_afecto
                    monto_exento
                    impto_adic
                    monto_iva
                    monto_total
                    iva_retenido
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroCompraResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroCompraResumenExcel(
    inputParams: {
      entidad: {
        rut_receptor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroCompraResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroCompraResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroCompraDetalle(
    inputParams: {
      entidad: {
        rut_receptor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroCompraDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_receptor
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    fecha_emision
                    cliente_proveedor_rut
                    cliente_nombre
                    monto_afecto
                    monto_exento
                    impto_adic
                    monto_iva
                    monto_total
                    iva_retenido
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroCompraDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerLibroCompraDetalleExcel(
    inputParams: {
      entidad: {
        rut_receptor: number;
        sucursal_codigo: number;
        anno: Date;
        mes: Date;
        listaTipoDocumento: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerLibroCompraDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerLibroCompraDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerTotalesLibroCompra(inputParams, callback: Function) {
    //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))
    this.gqlclient.query(
      {
        query: gql`
          query ($lista: [documentoInputType]) {
            documento {
              obtenerTotalesLibroCompra(lista: $lista) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cantidad_documento
                  monto_afecto
                  monto_exento
                  impto_adic
                  monto_iva
                  monto_total
                  iva_retenido
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerTotalesLibroCompra;
        callback({ mensajes, respuesta });
      }
    );
  }

  limpiarImpresionTablasLsof(
    inputParams: {
      entidad: {
        rut_emisor: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType) {
            documento {
              limpiarImpresionTablasLsof(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.limpiarImpresionTablasLsof;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerDocumentoCSRecorrido(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        recorrido_codigo: number;
        listaTipoDocumento: any[];
      };
      orden_envio: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType, $orden_envio: Int, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento {
              obtenerDocumentoCSRecorrido(entidad: $entidad, orden_envio: $orden_envio, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    fecha_emision
                    cliente_proveedor_rut
                    cliente_nombre
                    monto_total
                    vendedor_codigo
                    vendedor_nombre
                    comuna_codigo_facturacion
                    comuna_facturacion
                    ruta_codigo
                    mail_pdf
                    mail_xml
                    id_lsoft
                    impresion_doc
                    secuencia
                    recorrido_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerDocumentoCSRecorrido;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerPDFDocumento(
    inputParams: {
      entidad: {
        rut_emisor: number;
        sucursal_codigo: number;
        tipo_dte_codigo: number;
        folio: number;
        id_lsoft: number;
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoInputType) {
            documento {
              obtenerPDFDocumento(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutaArchivo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerPDFDocumento;
        callback({ mensajes, respuesta });
      }
    );
  }

  imprimirFactura(
    inputParams: {
      rut_empresa: number;
      sucursal_codigo: number;
      documento: boolean;
      copia_cedible: boolean;
      enviar_pdf: boolean;
      enviar_xml: boolean;
      orden_envio: number;
      listaDocumento: any[];
      rut_usuario: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query (
            $rut_empresa: Decimal
            $sucursal_codigo: Decimal
            $documento: Boolean
            $copia_cedible: Boolean
            $enviar_pdf: Boolean
            $enviar_xml: Boolean
            $rut_usuario: Decimal
            $orden_envio: Int
            $listaDocumento: [documentoInputType]
          ) {
            documento {
              imprimirFactura(
                rut_empresa: $rut_empresa
                sucursal_codigo: $sucursal_codigo
                documento: $documento
                copia_cedible: $copia_cedible
                enviar_pdf: $enviar_pdf
                enviar_xml: $enviar_xml
                orden_envio: $orden_envio
                rut_usuario: $rut_usuario
                listaDocumento: $listaDocumento
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut_emisor
                  tipo_dte_codigo
                  tipo_dte_nombre
                  folio
                  fecha_emision
                  cliente_proveedor_rut
                  cliente_nombre
                  monto_total
                  id_lsoft
                  vendedor_codigo
                  vendedor_nombre
                  mail_pdf
                  mail_xml
                  documento
                  copia_cedible
                  envio_pdf
                  envio_xml
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
        context: '{ timeout: 300000 }',
      },
      function (response) {
        //const timeoutLink = new ApolloLinkTimeout(50000);
        //timeoutLink.concat(response)
        // setTimeout(() => {
        //   response
        // }, 50000);
        const { mensajes, respuesta } = response.data.documento.imprimirFactura;
        callback({ mensajes, respuesta });
      }
    );
  }

  marcaDocumentoCompraNoProcesado(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($lista: [documentoInputType], $entidad: documento_no_procesadoInputType) {
            documento {
              marcaDocumentoCompraNoProcesado(lista: $lista, entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  rut_receptor
                  rut_emisor
                  tipo_dte_codigo
                  folio
                  no_procesado
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.marcaDocumentoCompraNoProcesado;
        callback({ mensajes, respuesta });
      }
    );
  }

  marcaDocumentoCompraProcesado(
    inputParams: {
      codigoBodega: number;
      mes: number;
      anno: number;
      mueveStock: boolean;
      lista: {
        rut_receptor: number;
        rut_emisor: number;
        sucursal_codigo: number;
        tipo_dte_codigo: number;
        folio: number;
        seleccion: boolean;
      }[];
    },
    callback: Function
  ) {
    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($lista: [documentoInputType], $sucursal_codigo: Decimal, $codigoBodega: Decimal, $mes: Int, $anno: Int, $mueveStock: Boolean) {
            documento {
              marcaDocumentoCompraProcesado(lista: $lista, sucursal_codigo: $sucursal_codigo, codigoBodega: $codigoBodega, mes: $mes, anno: $anno, mueveStock: $mueveStock) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  rut_receptor
                  rut_emisor
                  tipo_dte_codigo
                  tipo_dte_nombre
                  folio
                  fecha_recepcion
                  es_mov_inv_compra
                  es_cta_cte_compra
                  mes_recepcion
                  cliente_nombre
                  resultado
                  resultado_nombre
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.marcaDocumentoCompraProcesado;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerDocumentoCompra(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoDTOInputType) {
            documento {
              obtenerDocumentoCompra(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cabecera {
                    rut_emisor
                    sucursal_codigo
                    folio
                    tipo_dte_codigo
                    cliente_proveedor_rut
                    tipo_envio_codigo
                    tipo_traslado_codigo
                    condicion_pago_codigo
                    vendedor_codigo
                    tipo_devolucion_codigo
                    fecha_emision
                    fecha_recepcion
                    rut_receptor
                    direccion_completa_facturacion
                    comuna_facturacion
                    provincia_facturacion
                    region_facturacion
                    direccion_completa_despacho
                    comuna_despacho
                    princia_despacho
                    region_despacho
                    giro_cliente
                    fono_cliente
                    monto_descuento
                    monto_recargo
                    subtotal_neto
                    monto_total_neto
                    monto_iva
                    monto_afecto
                    monto_exento
                    subtotal
                    monto_total
                    nota_venta
                    orden_compra
                    fecha_registro
                    aplica_rebaja
                    aplica_recorrido
                    observaciones
                    ticket_sii
                    fecha_vencimiento
                    dia_emision
                    mes_emision
                    id_lsoft
                    motivo_devolucion_codigo
                    tipo_despacho_codigo
                    centro_costo_codigo
                    forma_pago_codigo
                    tipo_destinatario_codigo
                    es_entrega_gratuita
                    direccion_codigo
                    usuario_rut_usuario
                    tipo_ncnd_codigo
                    glosa_administrativa
                    cliente_nombre
                    vendedor_nombre
                    direccion_nombre
                    tipo_dte_nombre
                    es_cta_cte_compra
                    es_mov_inv_compra
                    id_xml
                  }
                  descuentosGlobales {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    es_porcentaje
                    monto_descuento
                    es_descuento
                    glosa
                    ind_facturacion
                  }
                  detalleDocumento {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    sku
                    formato_codigo
                    descripcion_producto
                    cantidad
                    precio_neto
                    precio_unitario
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    gasto_codigo
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    equivalencia_producto_id
                    producto_codigo
                    sku_erp
                    descripcion_erp
                    formato_erp
                    formato_nombre
                    precio_erp
                    total_erp
                    producto_valido
                    aplicacion_recargo
                    aplicacion_descuento
                    es_mov_inv_compra_detalle
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento.obtenerDocumentoCompra;
        callback({ mensajes, respuesta });
      }
    );
  }

  actualizarDetalleDocCompra(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documento_detalleDTOInputType) {
            documento_detalle {
              actualizarDetalleDocCompra(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  nro_linea
                  sku
                  formato_codigo
                  descripcion_producto
                  cantidad
                  precio_neto
                  precio_unitario
                  monto_total_neto
                  monto_total
                  es_producto_libre
                  gasto_codigo
                  motivo_devolucion_especifico_codigo
                  es_correcion_monto
                  equivalencia_producto_id
                  producto_codigo
                  sku_erp
                  descripcion_erp
                  formato_erp
                  formato_nombre
                  precio_erp
                  total_erp
                  producto_valido
                  aplicacion_descuento
                  aplicacion_descuento
                  atributos {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    tipo_atributo_codigo
                    nro_linea
                    impuesto_codigo
                    porcentaje
                    monto
                    es_porcentaje
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.actualizarDetalleDocCompra;
        callback({ mensajes, respuesta });
      }
    );
  }
}
